/**
 * StepIndicator - Registration progress indicator
 */
import { CheckCircle } from 'lucide-react';

const STEPS = [
  { num: 1, label: 'Classes' },
  { num: 2, label: 'Student' },
  { num: 3, label: 'Medical' },
  { num: 4, label: 'Guardian' },
  { num: 5, label: 'Card' },
  { num: 6, label: 'Account' }
];

export const StepIndicator = ({ currentStep }) => (
  <div className="flex justify-between items-center mb-8 px-4">
    {STEPS.map((s, idx) => (
      <div key={s.num} className="flex items-center">
        <div className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center font-bold text-sm ${
          currentStep > s.num ? 'bg-emerald-500 text-white' :
          currentStep === s.num ? 'bg-[#FF007F] text-white' : 'bg-white/10 text-white/40'
        }`}>
          {currentStep > s.num ? <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5" /> : s.num}
        </div>
        <span className={`ml-2 text-xs sm:text-sm hidden md:block ${
          currentStep >= s.num ? 'text-white' : 'text-white/40'
        }`}>
          {s.label}
        </span>
        {idx < STEPS.length - 1 && (
          <div className={`w-6 sm:w-12 md:w-20 h-0.5 mx-2 ${
            currentStep > s.num ? 'bg-emerald-500' : 'bg-white/10'
          }`} />
        )}
      </div>
    ))}
  </div>
);

export default StepIndicator;
